import { render, staticRenderFns } from "./CartTabItem.vue?vue&type=template&id=4fbae810"
import script from "./CartTabItem.vue?vue&type=script&lang=js"
export * from "./CartTabItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports